import { ActionFromReducer, createSlice } from '@reduxjs/toolkit';
import { Communication, getDataPayload, getDependencyDataPayload, getRecordPayload, InitialState, PositionEnum, Step,  } from '../modules/Timer/types';
import { Matter, TimeExpenseEntry } from '../modules/Timer/types-time-entry';
const initialState: InitialState = {
    timers: {
        data: [],
        rowCount: 0,
        hasMore: false
    },
    timer: {},
    timeExpenseEntry:{},
    currentTimer:{},
    dependencyData:{
        users:[],
        expenseCategories:[],
        expenseCodes:[],
        hourlyRate:0,
        isEnableUtbms:false,
        taskCodes:[],
        taxes:[],
        timeEntryCategories:[],
    },
    matters:[],
    steps:{
        steps:[],
        position:PositionEnum.Initial
    },
    communication:{},
    sendMailLoading:false,
    createEmailLogLoading:false,
    documents:[]
};

export const timerSlice = createSlice({
    name: 'timer',
    initialState,
    reducers: {
        getData: (state: InitialState, action: getDataPayload) => {
            state.timers.rowCount = action.payload.rowCount;
            state.timers.hasMore = action.payload.hasMore;


            if (action.payload.append) {
                const appendedData = [...state.timers.data!, ...action.payload.data!];
                state.timers.data = appendedData;
            }
            else {
                state.timers.data = action.payload.data;
            }

        },
        getRecord: (state: InitialState, action: getRecordPayload) => {
            state.timer = action.payload;
        },
        getCurrentTimer: (state: InitialState, action: getRecordPayload) => {
            state.currentTimer = action.payload;
        },
        getDependencyData: (state: InitialState, action: getDependencyDataPayload) => {
            state.dependencyData = action.payload
        },
        getMatterDependencyData: (state: InitialState, action: {payload:{matters:Matter[]}}) => {
            state.matters = action.payload.matters
        },
        getTimeEntry:(state:InitialState, action:{payload:TimeExpenseEntry})=>{
            state.timeExpenseEntry=action.payload
        },
        getSteps:(state:InitialState, action:{payload:{step:Step, position:number}})=>{
            const copiedSteps = state.steps.steps
            const findExisting = copiedSteps.find(st=>st.stepId===action.payload.step.stepId)
            if(!findExisting){
                copiedSteps.push(action.payload.step)
                state.steps.steps = copiedSteps
                state.steps.position=action.payload.position
            }   
        },
        getCommunication:(state:InitialState, action:{payload:Communication})=>{
            state.communication=action.payload
        },
        getSendMailLoading:(state:InitialState, action:{payload:boolean})=>{
            state.sendMailLoading=action.payload
        },
        getCreateEmailLogLoading:(state:InitialState, action:{payload:boolean})=>{
            state.createEmailLogLoading=action.payload
        },
        getDocuments:(state:InitialState, action:{payload:Document[]})=>{
            state.documents=action.payload
        }
    }
});

export const timerActions = timerSlice.actions;